import { FC } from 'react';

import { Box } from '@qwealth/qcore';

import { formatDateInUserTimezone, LONG_MONTH_DATE_AM_PM_TIME_FORMAT } from 'data/helpers/dateTimeHelper';
import { useAppSelector } from 'data/store';
import { selectUser } from 'data/selectors/userSelectors';
import InfoTag from 'components/common/SectionHeader/InfoTag';
import { StyledClientNotesHistoryComplianceApprovedCard } from './NoteHistory.styled';
import { ComplianceApprovalNote } from 'data/models/Compliance';

interface Props {
  note: ComplianceApprovalNote;
}

const ClientNotesHistoryComplianceApprovedCard: FC<Props> = ({ note }): JSX.Element => {
  const { timeZone } = useAppSelector(selectUser);
  return (
    <StyledClientNotesHistoryComplianceApprovedCard>
      <InfoTag tagTitle="Compliance Approved" icon="Check Mark" />
      <Box fontSize="small">
        By {note.approvedBy || ''} on{' '}
        {note.complianceApprovalDate ? formatDateInUserTimezone(note.complianceApprovalDate, timeZone, LONG_MONTH_DATE_AM_PM_TIME_FORMAT) : ''}
      </Box>
    </StyledClientNotesHistoryComplianceApprovedCard>
  );
};

export default ClientNotesHistoryComplianceApprovedCard;
